// The code in this file will load on every page of your site

import {submitForm} from 'public/submitForm.js';

$w.onReady(function () {
	// Write your code here
});

// Colin: This event occurs when the user clicks the newsletter subscription 'Submit' button.
export function newsletterSubscribeButton_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	var formFilled = $w('#newsletterInputName').value !== "" && $w('#newsletterInputEmail').value !== "";

	if (formFilled) {
		// Remember to change currentpage string
		// Colin: Call the public function, passing through all the desired form data.
		// Wix has some code in the background to "listen" for when this event occurs. If we end up moving away from the Wix platform, we may need to add this code in directly.
		var currentForm = "newsletterFooter"; 
		var newsletterDecline = false;
		console.log("Form Location: " + currentForm);
		submitForm($w("#newsletterInputName").value, "Newsletter", $w("#newsletterInputEmail").value, "", "", currentForm, newsletterDecline).then(function(r) {
        newsletterFormSubmissionMessage(r);
    });
		// console.log("Hello");
	} else {
		$w('#textNewsletterFormResponse').text = "Please provide a name and email address.";
		// $w('#textConsultFormResponse').show();
	}
		$w('#textNewsletterFormResponse').show();
}

// Colin: This function is intended to let the user know what happened to their form submission.
export function newsletterFormSubmissionMessage(submissionStatus) {
    // console.log('Submission status matches success?: ' + 'success' === submissionStatus);
    if ('error' === submissionStatus) {
        $w('#textNewsletterFormResponse').text = 'Submission failed.';
        // $w('#textConsultFormResponse').hidden = false;
        // console.log('Submission message changed to fail.');
    } else {
        $w('#textNewsletterFormResponse').text = "Thank you for subscribing!";
        // $w('#textConsultFormResponse').hidden = false;
        // console.log('Submission message changed to success.');
    }
}